import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import moment from "moment";
import { debounceTime, Subject } from "rxjs";

import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../../shared/constants/constants";
import { NotificationCommunication } from "../../../../shared/models/notification-center-model";
import { Adaa4ActionFilter, Adaa4NotificationsService } from "../../services/adaa4-notifications-service";
import { Adaa4StepperComponent } from "../adaa4-stepper/adaa4-stepper";

const SEARCH_DEBOUNCE_MS = 400;
const LATE_DAYS = 14;
const WARN_DAYS = 7;

type PendingTone = "ok" | "warn" | "late";

@Component({
  selector: "adaa-adaa4-notifications-list",
  imports: [TranslatePipe, RouterLink, Adaa4StepperComponent],
  templateUrl: "./adaa4-notifications-list.html",
  styleUrl: "./adaa4-notifications-list.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Adaa4NotificationsListComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _searchTerm = new Subject<string>();

  readonly notifications = inject(Adaa4NotificationsService);
  readonly AdaaHelper = AdaaHelper;
  readonly actionFilters: Adaa4ActionFilter[] = ["create", "update", "delete", "dataEntry"];

  public ngOnInit(): void {
    this._searchTerm
      .pipe(debounceTime(SEARCH_DEBOUNCE_MS), takeUntilDestroyed(this._destroyRef))
      .subscribe((term) => this.notifications.setSearch(term));

    this.notifications.reload();
  }

  public onSearch(term: string): void {
    this._searchTerm.next(term.trim());
  }

  public open(notification: NotificationCommunication): void {
    this._router.navigate(["/homepage/notifications", notification.id]);
  }

  public startDate(notification: NotificationCommunication): string {
    return moment(notification.createTS).utcOffset(Constants.uaeTimezone).format("DD/MM/YYYY");
  }

  public name(notification: NotificationCommunication): string {
    return (
      AdaaHelper.getItemValueByToken(notification, "itemName") || AdaaHelper.getItemValueByToken(notification, "title")
    );
  }

  public pendingTone(days: number): PendingTone {
    if (days >= LATE_DAYS) return "late";
    if (days >= WARN_DAYS) return "warn";
    return "ok";
  }
}
